module.exports = __webpack_public_path__ + "static/media/cherry-2.1b68de50.png";